<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="22000048" />
    <!-- <ImportDialog ref="importDialog"
      title="客户导入"
      fileUrl="/file/客户档案导入模板.xlsx"
      @sub="handleImport"
    />-->
    <section slot="titleRight">
      <qx-permpisions permpisions="1003010201">
        <el-button type="primary" plain @click="() => toEdit('', 1)"
          >车辆维护费用报销</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="1003010202">
        <el-button type="primary" plain @click="() => toEdit('', 2)"
          >订单费用报销</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="1003010203">
        <el-button type="primary" plain @click="() => toFeeDetail()"
          >查看报销明细</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="1003010207">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleFeePaymentParBO.ajax?cmd=queryVehicleFeeBeanOutPage"
          :params="fullSearchData"
          bizName="车辆费用报销数据"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'busiCode'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-if="scope.column.property === 'applyUserName'">
                  <el-popover
                    trigger="hover"
                    :content="`司机手机：${scope.row.applyMobilePhone || ''}`"
                  >
                    <div slot="reference" class="primary cur">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </el-popover>
                </section>
                <section v-if="scope.column.property === 'receName'">
                  <el-popover
                    trigger="hover"
                    :content="`收款人手机：${scope.row.receMobilePhone || ''}`"
                  >
                    <div slot="reference" class="primary cur">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </el-popover>
                </section>
                <section v-if="scope.column.property === 'serviceName'">
                  <span
                    class="primary cur"
                    @click="toServiceDetail(scope.row)"
                    >{{ scope.row[scope.column.property] }}</span
                  >
                </section>
                <section v-if="scope.column.property === 'payAmt'">
                  <span>{{ scope.row[scope.column.property] / 100 }}</span>
                </section>
                <section
                  v-if="
                    scope.column.property !== 'busiCode' &&
                    scope.column.property !== 'applyUserName' &&
                    scope.column.property !== 'receName' &&
                    scope.column.property !== 'serviceName' &&
                    scope.column.property !== 'payAmt'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1003010204',
                    showCondition:
                      (scope.row.state === 0 || scope.row.state === 4) &&
                      scope.row.isJurisdiction == true,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    permpisions: '1003010205',
                    showCondition:
                      (scope.row.state === 0 || scope.row.state === 1) &&
                      scope.row.sourceType !== 2,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    permpisions: '1003010206',
                    showCondition:
                      (scope.row.state === 0 || scope.row.state === 1) &&
                      scope.row.sourceType != 2,
                    name: '取消',
                    event: () => cancel(scope.row.payId),
                  },
                  {
                    name: '日志',
                    event: () => showLog(scope.row.payId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  // carCostList,
  carCostCancelApply,
  queryVehicleFeeBeanOutPage,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'busiCode', label: '报销单号', fixed: true },
          { prop: 'applyTime', label: '申请时间' },
          { prop: 'applyUserName', label: '申请人' },
          { prop: 'payAmt', label: '申请金额（元）' },
          { prop: 'serviceName', label: '服务商' },
          { prop: 'detailsNumber', label: '明细笔数' },
          { prop: 'orgName', label: '费用归属' },
          { prop: 'receName', label: '收款方' },
          { prop: 'stateName', label: '状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryVehicleFeeBeanOutPage,
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核车辆费用' : `车辆费用详情-${item.busiCode}`,
        url: `/manage/cost/car/car/feeReimbursementDetail?id=${item.payId}&type=${type}`,
        full: true,
      });
    },
    toFeeDetail () {
      this.jump({
        label: '报销明细',
        url: '/manage/cost/car/feeDetail?vehicleFeeType=1',
        full: true,
      });
    },
    toServiceDetail (item) {
      this.jump({
        label: '服务商详情',
        url: `/manage/service/merchant/manage/detail?id=${item.serviceId}`,
        full: true,
      });
    },
    toEdit (item, vehicleFeeType) {
      let label = '';
      if (item) {
        label = '修改车辆费用报销';
        if (item.vehicleFeeType === 2) {
          label = '修改订单费用报销';
        }
        vehicleFeeType = item.vehicleFeeType;
      } else {
        if (vehicleFeeType === 1) {
          label = '新增车辆费用报销';
        } else {
          label = '新增订单费用报销';
        }
      }
      this.jump({
        label,
        url: `/manage/cost/car/car/edit?id=${item ? item.payId : ''}&vehicleFeeType=${vehicleFeeType}`,
        full: true,
      });
    },
    async cancel (payId) {
      const confirmRes = await this.$confirm('是否确定取消申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const delRes = await carCostCancelApply({
          payId,
        });
        if (!delRes.failed) {
          this.$message({
            type: 'success',
            message: '已成功取消',
          });
          this.getData();
        }
      }
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
